<template>
  <div>
    <v-multiselect-listbox
      :options="optionList"
      :reduce-display-property="(option) => option.label"
      :reduce-value-property="(option) => option.id"
      search-options-placeholder="جستجو..."
      selected-options-placeholder="جستجو..."
      
      v-model="selectedList"
      :value="selectedList"
      @change="setMultiSelect"
      style="direction: ltr"
    ></v-multiselect-listbox>

    <div>{{ selectedList }}</div>
  </div>
</template>

<script>
import vMultiselectListbox from "vue-multiselect-listbox";
export default {
  components: { vMultiselectListbox },
  
  data() {
    return {
      optionList: [
        { label: "Alabama", id: "al" },
        { label: "California", id: "cal" },
      ],

      selectedList: [],
    };
  },

  methods: {
    setMultiSelect() {},
  },
};
</script>

<style>
</style>